export default __webpack_public_path__ + "assets/a244f8391daf94f25d45b8a47e4082ca.png";